import { Suspense, lazy } from "react";
import { HiveTooltips } from "@shared/components/hive/HiveTooltips";

const AdminPage = lazy(() => import("@pages/admin/ui/AdminPage"));
const ForgotPasswordPage = lazy(
  () => import("@pages/auth/ui/ForgotPasswordPage"),
);
const LoginPage = lazy(() => import("@pages/auth/ui/LoginPage"));
const RegisterPage = lazy(() => import("@pages/auth/ui/RegisterPage"));
const ResetPasswordPage = lazy(
  () => import("@pages/auth/ui/ResetPasswordPage"),
);
const ResendVerificationPage = lazy(
  () => import("@pages/auth/ui/ResendVerificationPage"),
);
const VerifyEmailPage = lazy(() => import("@pages/auth/ui/VerifyEmailPage"));
const LeaderboardPage = lazy(
  () => import("@pages/leaderboard/ui/LeaderboardPage"),
);
const UserProfilePage = lazy(() => import("@pages/user/ui/UserProfilePage"));

const normalizePathname = (pathname: string) => {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }

  return pathname;
};

const App = () => {
  const pathname =
    typeof window !== "undefined"
      ? normalizePathname(window.location.pathname)
      : "/";

  return (
    <Suspense fallback={null}>
      {/* the site's own tooltips on the Hive pages */}
      <HiveTooltips />
      {pathname.startsWith("/admin") ? <AdminPage /> : null}
      {pathname === "/register" ? <RegisterPage /> : null}
      {pathname === "/login" ? <LoginPage /> : null}
      {pathname === "/forgot-password" ? <ForgotPasswordPage /> : null}
      {pathname === "/reset-password" ? <ResetPasswordPage /> : null}
      {pathname === "/verify-email" ? <VerifyEmailPage /> : null}
      {pathname === "/resend-verification" ? <ResendVerificationPage /> : null}
      {pathname.startsWith("/u/") && pathname.length > 3 ? (
        <UserProfilePage />
      ) : null}
      {!pathname.startsWith("/admin") &&
      pathname !== "/register" &&
      pathname !== "/login" &&
      pathname !== "/forgot-password" &&
      pathname !== "/reset-password" &&
      pathname !== "/verify-email" &&
      pathname !== "/resend-verification" &&
      !(pathname.startsWith("/u/") && pathname.length > 3) ? (
        <LeaderboardPage />
      ) : null}
    </Suspense>
  );
};

export default App;
